<template>
    <div class="col-12">
        <b-card>
            <h3 class="text-center p-0 m-0">Información de pago</h3>
            <div class="text-center">
                <b><span class="red">* </span>Modificar esta información de pago afectará al usuario, es decir al cobro de deportistas, abonos, etc...</b>
            </div>
            <InformacionPagoPerfil
                :tid="configuracion.hash_teatro"
                :admin="true"
                @update="$emit('actualizarInfo')"
            />
        </b-card>
    </div>
</template>

<script>
import InformacionPagoPerfil from '@/components/common/usuario/components/InformacionPagoPerfil';

export default {
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        }
    },
    components: {
        InformacionPagoPerfil
    }
}
</script>